import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarHoverDraftBooking(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);
    
    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="DraftBooking"?"":"DraftBooking")} title="Draft Booking" className={props.activeMenu == "DraftBooking" ? "sidenav-collapsed-active pointer px-0 sidenavbar-text":"pointer px-0 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("draftbooking:draftbooking:view")?false:true}>
                <span className="mx-2 sidenavbar-text">Draft Booking
                    <i className={showMenu=="DraftBooking"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>

            <ul className={showMenu == "DraftBooking" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/draftbooking/shipment")} title="Shipment" 
                className={props.activeSubMenu == "Shipment" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("draftbooking:shipment:view")?false:true}>
                    Shipment
                </a>
            </ul>
            <ul className={showMenu == "DraftBooking" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => [navigate("/draftbooking/draftbookingrequest") , window.location.reload()]} title="Draft Booking Request" 
                className={props.activeSubMenu == "DraftBookingRequest" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:view")?false:true}>
                    Draft Booking Request
                </a>
            </ul>
            <ul className={showMenu == "DraftBooking" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/draftbooking/customerdraftbookingrequest")} title="Draft Booking Request" 
                className={props.activeSubMenu == "CustomerDraftBookingRequest" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("draftbooking:customerdraftbookingrequest:view")?false:true}>
                    Draft Booking Request
                </a>
            </ul>
            <ul className={showMenu == "DraftBooking" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/draftbooking/approveddraftbooking")} title="Approved Draft Booking" 
                className={props.activeSubMenu == "ApprovedDraftBookingRequest" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("draftbooking:approveddraftbooking:view")?false:true}>
                    <span className="mx-3">Approved Request</span>
                </a>
            </ul>
            <ul className={showMenu == "DraftBooking" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/draftbooking/managetariff")} title="Manage Tariff" 
                className={props.activeSubMenu == "ManageTariff" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("draftbooking:managetariff:view")?false:true}>
                    <span className="mx-3">Manage Tariff</span>
                </a>
            </ul>
            <ul className={showMenu == "DraftBooking" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/draftbooking/tariffcosting")} title="Tariff Costing" 
                className={props.activeSubMenu == "TariffCosting" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("draftbooking:tariffcosting:view")?false:true}>
                    <span className="mx-3">Tariff Costing</span>
                </a>
            </ul>
            <ul className={showMenu == "DraftBooking" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/draftbooking/taskmanagement")} title="Task Management" 
                className={props.activeSubMenu == "TaskManagement" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("draftbooking:taskmanagement:view")?false:true}>
                    <span className="mx-3">Task Management</span>
                </a>
            </ul>
        </>
    );
}

export default SideNavBarHoverDraftBooking;
